/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState} from 'react'
import axios from 'axios'
import Calendar from '../calendar/Calendar'
import { useEffect } from 'react'
import EditDocuments from './EditDocuments'
import { useDispatch } from 'react-redux';
import {
    addImages
} from '../features/imagesSliceFile/imagesSlice'

var imageArrayPermanent = []
var listOfVans = []
var numberKeeper = 0

var outsideImageFile = ''

const FormsDocuments = (props) => {
    // redux stuff
    const dispatch = useDispatch()

    var CryptoJS = require("crypto-js");
    const [ valueForSubmit, setValueForSubmit ] = useState('')
    const [ dateSelected, setDateSelected ] = useState(new Date())
    const [ manualDate, setManualDate ] = useState('')
    const [ calendarGate, setCalendarGate] = useState(false)
    const [ nameFromListArray, setNameFromListArray] = useState([])
    const [ nameFromList, setNameFromList] = useState('')
    const [ displayNameArray, setDisplayNameArray ] = useState('names_list_array_container_none')
    const [ countryFromListArray, setCountryFromListArray] = useState([])
    const [ countryFromList, setCountryFromList] = useState()
    const [ displayCountryArray, setDisplayCountryArray] = useState('names_list_array_container_none')
    const [ submitPressed, setSubmitPressed] = useState('Submit')
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ arrayOfImages, setArrayOfImages ] = useState([])
    const [ dateOption, setDateOption ] = useState(true)
    const [ countryOption, setCountryOption ] = useState(true)
    const [ optionsSelections, setOptionsSelections ] = useState(null)
    const [ editPage, setEditPage ] = useState(null)
    const [ manualGate, setManualGate ] = useState(false)
    const [ vanOwner, setVanOwner ] = useState(false)
    const [ registration, setRegistration ] = useState('')
    const [ vehicleType, setVehicleType ] = useState('')
    const [ submissionToggle, setSubmissionToggle ] = useState(false)
    const [ nonOwnerRegistration, setNonOwnerRegistration ] = useState('')
    const [ nonOwnerToggle, setNonOwnerToggle ] = useState(false)
    const [ vanList, setVanList ] = useState([])
    const [ temporaryReg, setTemporaryReg ] = useState('')
    const [ minorWarning, setMinorWarning ] = useState(null)
    const [ appPage, setAppPage ] = useState(false)
    const [ sizeError, setSizeError ] = useState(null)
    const [ localPercent, setLocalPercent ] = useState(0)
    const [ percentGate, setPercentGate ] = useState(false)
    const [ dateText, setDateText ] = useState('Expiry Date:')
    const [ manualDateDiv, setManualDateDiv] = useState(null)
    const [ theCalendar, setTheCalendar ] = useState(null)
    const [ vanSizeDropdown, setVanSizeDropdown ] = useState(null)
    const [ regList, setRegList ] = useState([])
    const [ shortTermLabel, setShortTermLabel ] = useState('')
    const [ ownershipButton, setOwnershipButton ] = useState(null)
    const [ assignVanButton, setAssignVanButton ] = useState(null)
    const [ submitFilesDiv, setSubmitFilesDiv ] = useState(null)

    // state for file value
    const [ fileValue, setFileValue ] = useState(null)

    // search bar
    const [ inputText, setInputText ] = useState('')

    // get list of vans and registration
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            });

        return response ? response.json() : console.log('no reponse')
    };
    useEffect( () => {
        let vanList = []

        getData('https://backendpajamas.herokuapp.com/vehicles/').then( response => {
            setVanList(response.results)
            listOfVans = response.results
            getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                let registrationVanList = []
                let registrationDriverList = []
                response.results.forEach( driver => {
                    if (driver.complianceCheck) {
                        registrationDriverList.push(driver.complianceCheck)
                    }
                })
                listOfVans.forEach( van => {
                    registrationVanList.push(van.registration)
                })
                setRegList(registrationVanList)
            })
        })
    }, [])

    // map props to state
    useEffect( () => {
        if (props.selectedDriver) {
            setVanOwner(props.selectedDriver.vanOwner)
            setNonOwnerRegistration(props.selectedDriver.complianceCheck)
        }
    }, [props])

    // useEffect to render the number changes
    useEffect( () => {
        if (percentGate) {
            setSizeError(
                <div className='sizeError'>
                    <h3>Document is over 10Mb, attempting to minify</h3>
                    <div class="meter">
                        <span className='insideNumbers'>{`${localPercent}%`}</span>
                        <span className='barStyle'>
                        </span>
                    </div>
                </div>
            )
        }
    }, [localPercent, percentGate] )

    // save image to cloudinary
    const uploadImage = (e) => {
        setFileValue(e.target.files)
        outsideImageFile = e.target.files
        uploadNewImage(e)
    }

    // handle adding an image
    var uploadNewImage = (e) => {
        setFileValue(e.target.files)
        async function getData(url = '') {
            const bloby = await fetch(url).then(r => r.blob());
            return bloby ? bloby : console.log('no reponse')
        };
        if (e.target.files) {
            const files = e.target.files
            if (files[0].size > 10000000) {
                setPercentGate(true)
                let myInterval = setInterval( () => {
                    numberKeeper++
                    setLocalPercent(numberKeeper)
                }, 100)
                // myInterval()
                setTimeout(() => {
                    clearInterval(myInterval)
                }, 10000);


                // data is too large to push to cloudinary
                const data = new FormData()
                data.append('file', files[0])

                // compress the data
                axios.post('https://v2.convertapi.com/convert/pdf/to/compress?Secret=MAZaTVjQOH5H0qM7&StoreFile=true', data).then(response => {
                    if (response.status === 200) {
                        if (response.data.Files[0].FileSize < 10000000) {
                            setPercentGate(false)
                            setSizeError(
                                <div className='sizeError'>
                                    <h3>Minified successfully to {Math.floor(response.data.Files[0].FileSize/1000000)}mb uploading Image...</h3>
                                </div>
                            )
                            getData(response.data.Files[0].Url).then( response => {
                                const data = new FormData()
                                data.append('file', response)
                                data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET)
                                data.append("api_key", process.env.REACT_APP_CLOUDINARY_API_KEY)
                                axios.post(process.env.REACT_APP_UPLOAD_IMAGE, data).then(response => {
                                    if (response.status === 200) {
                                        setTimeout( () => {
                                            setSizeError(null)
                                        }, 2000)
                                        setSizeError(
                                            <div className='sizeError'>
                                                <h3>Succesfully Uploaded</h3>
                                            </div>
                                        )
                                    } else {
                                        setSizeError(
                                            <div className='sizeError'>
                                                <h3>Something went wrong</h3>
                                            </div>
                                        )
                                    }
                                    let myOtherResponse = ''
                                    setValueForSubmit(myOtherResponse ? myOtherResponse : response.data.secure_url)
                                    outsideImageFile = myOtherResponse ? myOtherResponse : response.data.secure_url
                                    // e.target.files = null
                                })
                            })
                        }
                    } else {
                        setTimeout(() => {
                            setSizeError(null)
                        }, 3000)
                        setSizeError(
                            <div className='sizeError'>
                                <h3>Something went wrong, if document was a pdf, then it is too large. 
                                    If document was not a pdf, non-pdf minification has not been implemented yet. </h3>
                            </div>
                        )
                    }
                })
            } else {
                e.target.files = null
                const data = new FormData()
                data.append('file', files[0])
                data.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET)
                data.append("api_key", process.env.REACT_APP_CLOUDINARY_API_KEY)
                axios.post(process.env.REACT_APP_UPLOAD_IMAGE, data).then(response => {
                    let myOtherResponse = ''
                    outsideImageFile = myOtherResponse ? myOtherResponse : response.data.secure_url
                    setValueForSubmit(myOtherResponse ? myOtherResponse : response.data.secure_url)
                })
            }
        }
    }

    // get rid off error screen
    const handleDeleteError = () => {
        setErrorMessage(null)
        setNonOwnerToggle(false)
        setSubmissionToggle(false)
    }

    // date toggle
    const handleDateToggle = () => {
        dateOption ? setDateOption(false) : setDateOption(true)
    }
    
    // handle country toggle
    const handleCountryToggle = () => {
        countryOption ? setCountryOption(false) : setCountryOption(true)
    }

    ////////// HANDLING ADDING VAN TO OWNER /////////

    // function for finding last node
    const awaitAllResponses = async function (nextUuid) {

        // make a fragment
        const fragment = await getData(`https://backendpajamas.herokuapp.com/compliancevan/${nextUuid}/`)

        // if there is a next entry
        if (fragment.next) {
            // return the array with the async function added on
            return [fragment, (await awaitAllResponses(fragment.next))].flat()
        } else {
            // return the data
            return [fragment]
        }

    }

    // submitting van non ownership
    const vanNonOwnershipSubmit = () => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        if (temporaryReg) {
            // check if there is already a compliance van
            if (props.selectedDriver.Compliance_Van) {

                // make a new node
                postData('https://backendpajamas.herokuapp.com/compliancevan/', {
                    Assighned_Date: new Date().toDateString(),
                    Driver_Id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`,
                    vehicle_Id: temporaryReg,
                }).then( responseInitial => {
                    // find the last node
                    awaitAllResponses(props.selectedDriver.Compliance_Van).then( response => {
                        // point the previous node at it
                        putData(`https://backendpajamas.herokuapp.com/compliancevan/${response[response.length-1].Compliance_Van_Id}/`, {
                            next: responseInitial.Compliance_Van_Id,
                            Driver_Id: responseInitial.Driver_Id,
                            Returned_Date: new Date().toDateString()
                        }).then( responsePut => {

                            // change the driver pointer
                            putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                Compliance_Van: responsePut.Compliance_Van_Id,
                                complianceCheck: temporaryReg,
                                compliance_list: [...props.selectedDriver.compliance_list]
                            }).then( response => {

                                // change the ui
                                setErrorMessage(null)
                                setNonOwnerToggle(false)
                                setNonOwnerRegistration(response.complianceCheck)
                            })
                        })
                    })
                })
            } else {
                // create new node
                postData('https://backendpajamas.herokuapp.com/compliancevan/', {
                    Assighned_Date: new Date().toDateString(),
                    Driver_Id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`,
                    vehicle_Id: temporaryReg,
                }).then( response => {
                    // point driver at head node
                    putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                        Compliance_Van: response.Compliance_Van_Id,
                        complianceCheck: temporaryReg,
                        compliance_list: [...props.selectedDriver.compliance_list]
                    }).then( response => {
                        setErrorMessage(null)
                        setNonOwnerToggle(false)
                        setNonOwnerRegistration(response.complianceCheck)
                    })
                })
            }
        } else {
            setMinorWarning(
                <div className='minorWarning'>
                    <h3>Please Select a Registration to submit</h3>
                </div>
            )
            setTimeout( () => {
                setMinorWarning(null)
            }, 3000)
        }
    }

    // submit van ownership
    const vanOwnershipSubmit = () => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        let myBool = vanOwner === true ? false : true
        // check if there is already a compliance van
        if (props.selectedDriver.Compliance_Van) {

            // make a new node
            postData('https://backendpajamas.herokuapp.com/compliancevan/', {
                Assighned_Date: new Date().toDateString(),
                Driver_Id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`,
                vehicle_Id: registration,
            }).then( responseInitial => {

                // find the last node
                awaitAllResponses(props.selectedDriver.Compliance_Van).then( response => {
                    // point the previous node at it
                    putData(`https://backendpajamas.herokuapp.com/compliancevan/${response[response.length-1].Compliance_Van_Id}/`, {
                        next: responseInitial.Compliance_Van_Id,
                        Driver_Id: responseInitial.Driver_Id,
                        Returned_Date: new Date().toDateString()
                    }).then( responsePut => {

                        // change the driver pointer
                        putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                            Compliance_Van: response.Compliance_Van_Id,
                            vanOwner: myBool,
                            registration: registration.length > 0 ? registration : null,
                            vtype: vehicleType.length > 0 ? vehicleType : null,
                            compliance_list: [...props.selectedDriver.compliance_list]
                        }).then( response => {

                            // change the ui
                            setErrorMessage(null)
                            setSubmissionToggle(false)
                            setVanOwner(response.vanOwner)
                        })
                    })
                })
            })
        } else {
            postData('https://backendpajamas.herokuapp.com/compliancevan/', {
                Assighned_Date: new Date().toDateString(),
                Driver_Id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`,
                vehicle_Id: registration,
            }).then( response => {
                console.log(response)
                putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                    Compliance_Van: response.Compliance_Van_Id,
                    vanOwner: myBool,
                    registration: registration.length > 0 ? registration : null,
                    vtype: vehicleType.length > 0 ? vehicleType : null,
                    compliance_list: [...props.selectedDriver.compliance_list]
                }).then( response => {
                    setErrorMessage(null)
                    setSubmissionToggle(false)
                    setVanOwner(response.vanOwner)
                })
            })
        }
    }

    // handle state for inputting van
    const handleChangeReg = (e) => {
        e.target.name === 'reg' ? setRegistration(e.target.value) : setVehicleType(e.target.value)
    }

    // make the sandard of large van options dropdown
    const handleDropdown = () => {
        const handleSizeSelection = (e, theValue) => {
            setVehicleType(theValue)
            setVanSizeDropdown(null)
        }

        setVanSizeDropdown(
            <div className='vanSizeDropdown'>
                <h3 onClick={(e, ralph) => handleSizeSelection(e, 'Standard')}>Standard</h3>
                <h3 onClick={(e, ralph) => handleSizeSelection(e, 'Large')}>Large</h3>
            </div>
        )
    }

    useEffect( () => {
        if (submissionToggle) {
            if (vanOwner !== true) {
                setErrorMessage(
                    <div className='errorMessageAllPages'>
                        <h2 id='errorMessage'>Please add a registration and vehicle type </h2>
                        <div className='inputsContainers'>
                            <h4 className='inputComplaince'>Registration:</h4>
                            <input type="text" name='reg'  value={registration} onChange={handleChangeReg}/>
                            <h4 className='inputComplaince'>Type:</h4>
                            <input type="text" name='type'  value={vehicleType} onClick={handleDropdown} autocomplete="off"/>
                            {vanSizeDropdown}
                        </div>
                        <div className='docsButtonsContainers'>
                            <button className='errorButtonReturn' onClick={handleDeleteError}>Return</button>
                            <button className='errorButtonSubmit' onClick={vanOwnershipSubmit}>Submit</button>
                        </div>
                    </div>
                )
            } else {
                vanOwnershipSubmit()
            }
        }
    }, [submissionToggle, registration, vehicleType, vanSizeDropdown])

    // handle adding ownership for the van
    const handleOwnerToggle = () => {
        if (vanOwner) {
            handleRemoveVan()
        }
        else {
            setSubmissionToggle(true)
        }
    }

    // selected Registration
    const handleSelectRegistration = (e, item) => {
        setTemporaryReg(item)
    }

    // function for removing the van from the driver
    const handleRemoveVan = () => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        postData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
            complianceCheck: null,
            vanOwner: false
        }).then( response => {
            setSubmissionToggle(true)
            setErrorMessage(null)
            setNonOwnerToggle(false)
            setNonOwnerRegistration(response.complianceCheck)
        })
    }

    const handleChangeText = (e) => {
        setInputText(e.target.value)
    }

    useEffect( () => {
        if (nonOwnerToggle) {
            let vanRegList = []
            regList.sort((a, b) => (a > b) ? 1 : -1)
            regList.forEach( element => {
                if (inputText.length > 0) {
                    if (element.toLowerCase().includes(inputText.toLowerCase())) {
                        vanRegList.push(
                        <h3 
                            className='vanListItems' 
                            onClick={(e, item) => handleSelectRegistration(e, element)}
                        >{element}</h3>
                        )
                    }
                }
            })
            setErrorMessage(
                <div className='errorMessageCompliance'>
                    <h1 id='errorMessage'>Please pick a van registration to assign to driver</h1>
                    <h3>Selected Registration: {temporaryReg}</h3>
                    <input type="text" value={inputText} onChange={handleChangeText}/>
                    <div className='listOfVanReg'>
                        {vanRegList}
                    </div>
                    {minorWarning}
                    <div className='docsButtonsContainers'>
                        <button className='errorButtonReturn' onClick={handleDeleteError}>Return</button>
                        <button className='errorButtonReturn' id='spaceThisSome' onClick={handleRemoveVan}>Remove</button>
                        <button className='errorButtonSubmit' onClick={vanNonOwnershipSubmit}>Submit</button>
                    </div>
                </div>
            )
        }
    }, [nonOwnerToggle, temporaryReg, minorWarning, inputText])

    // handle non owner toggle
    const handleNonOwnerToggle = () => {
        setNonOwnerToggle(true)
        nonOwnerToggle === true ? setNonOwnerToggle(false) : setNonOwnerToggle(true)
    }

    // toggling ownership of a vehicle
    useEffect( () => {
        let localDriver = null
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                });

            return response ? response.json() : console.log('no reponse')
        };
        getData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`).then( response => {
            if (response.vanOwner) {
                if (response.registration) {
                    setOwnershipButton(
                        <div className='compliance_add_driver_button_submit_van_owner_true' onClick={handleOwnerToggle}>
                            <span className='span_in_complaince_button_van_owner_true'>Van Owner: {vanOwner  === true ? 'True' : 'False'} | {response.registration}</span>
                        </div>
                    )
                } else {
                    setOwnershipButton(
                        <div className='compliance_add_driver_button_submit_van_owner_false' onClick={handleOwnerToggle}>
                            <span className='span_in_complaince_button_van_owner_false'>Van Owner: {vanOwner  === true ? 'True' : 'False'}</span>
                        </div>
                    )
                }
            } else if (!response.complianceCheck) {
                setOwnershipButton(
                    <div className='compliance_add_driver_button_submit_van_owner_false' onClick={handleOwnerToggle}>
                        <span className='span_in_complaince_button_van_owner_false'>Van Owner: {vanOwner  === true ? 'True' : 'False'}</span>
                    </div>
                )
            } else {
                setOwnershipButton(<div className='spacerDivVanReg'></div>)
            }
        })
    }, [vanOwner, assignVanButton])

    // if not owner, add registration to person
    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                });

            return response ? response.json() : console.log('no reponse')
        };
        getData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`).then( response => {
            if (!response.vanOwner) {
                if (nonOwnerRegistration) {
                    setAssignVanButton(
                        <div className='compliance_add_driver_button_submit_van_owner_true_non' onClick={handleNonOwnerToggle}>
                            <span className='span_in_complaince_button_van_owner_false_non'>Assigned Van: {nonOwnerRegistration !== null ? nonOwnerRegistration : 'None'}</span>
                        </div>
                    )
                } else {
                    setAssignVanButton(
                        <div className='compliance_add_driver_button_submit_van_owner_false_non' onClick={handleNonOwnerToggle}>
                            <span className='span_in_complaince_button_van_owner_true_non'>Assigned Van: None</span>
                        </div>
                    )
                }
            } else if (!response.registration){
                setAssignVanButton(
                    <div className='compliance_add_driver_button_submit_van_owner_false_non' onClick={handleNonOwnerToggle}>
                        <span className='span_in_complaince_button_van_owner_true_non'>Assigned Van: None</span>
                    </div>
                )
            } else {
                setAssignVanButton(<></>)
            }
        })
    }, [vanOwner, nonOwnerRegistration])
    // handle rendering application page component
    const handleAppPage = () => {
        setAppPage(true)
    }

    // handling the selection for the options
    useEffect( () => {
        setOptionsSelections(
            <div className='documentsForVerificationTop'>
                <div className='compliance_add_driver_button_submit' onClick={handleDateToggle}>
                    <span className='span_in_complaince_button'>Date Selection</span>
                </div>
                <div className='compliance_add_driver_button_submit' onClick={handleCountryToggle}>
                    <span className='span_in_complaince_button'>Country Selection</span>
                </div>
                {ownershipButton}
                {assignVanButton}
            </div>
        )

    }, [countryOption, dateOption, vanOwner, nonOwnerRegistration, ownershipButton, assignVanButton])

    // const manage disable editing
    const returnFunction = (response) => {
        let localArrayOfImages = []
        let localArray = []
        if (imageArrayPermanent.length > 0) {
            localArrayOfImages = [...imageArrayPermanent]
            localArrayOfImages.forEach( (ele, id) => {
                if (ele.image_id === response.image_id) {
                    localArrayOfImages[id] = response
                }
            })
        }
        imageArrayPermanent = localArrayOfImages
        localArrayOfImages.forEach( (ele, id) => {
            if (!ele.storageBool) {
                localArray.push(
                    <div key={id} className='imageClassVerification'>
                        <div className="formNameContainer">
                            {ele.name}
                        </div>
                        <div>
                            <img src={ele.imagesLink} className='imageOnVerification' alt={ele.name} onClick={(e, stuff) => handleEditDocuments(e, ele)}/>
                        </div>
                    </div>
                )
            }
        })
        setArrayOfImages(localArray)
        setEditPage(null)
    }

    // const make documents editable
    const handleEditDocuments = (e, theImage) => {
        setEditPage(
            <EditDocuments 
                image={theImage}
                returnFunc={returnFunction}
                station={props.station}
                superUser={props.superUser}
                selectedDriver={props.selectedDriver}
            />
        )
    }

    // handle submitting document to backend
    var handleSubmit = (e) => {
        e.preventDefault()
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        if (outsideImageFile.length > 0) {
            let localArrayForCheck = []
            props.selectedDriver.imgArray.forEach( ele => {
                if (!ele.storageBool) {
                    localArrayForCheck.push(ele.name)
                }
            })
            if (localArrayForCheck.includes(nameFromList) && nameFromList !== 'DVLA Check' && nameFromList !== 'Other') {
                setErrorMessage(
                    <div className='errorMessageAllPages'>
                        <h3 id='errorMessage'>Driver already has {nameFromList} </h3>
                        <button className='errorButton' onClick={handleDeleteError}>Return</button>
                    </div>
                )
            } else {
                // handle application packageselse 
                if (props.superUser) {
                    async function postData(url = '', data = {}) {
                        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                        let originalText = bytes.toString(CryptoJS.enc.Utf8);
                        const response = await fetch(url, {
                            method: 'POST', 
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Token ${originalText}`
                            },
                            body: JSON.stringify(data)
                            });
            
                        return response ? response.json() : console.log('no reponse')
                    };

                    // handle not entering date
                    const dateSelector = () => {
                        if (manualDate) {
                            try {
                                new Date(manualDate)
                            } catch (error) {
                                console.log(error)
                            }
                            return new Date(manualDate).toDateString()
                        }
                        else if (dateOption) {
                            return dateSelected.toDateString()
                        } 
                        else {
                            return 'Thu Jan 3 2030'
                        }
                    }
                    postData(`https://backendpajamas.herokuapp.com/images/`, {
                        imagesLink: outsideImageFile,
                        name: nameFromList,
                        countryOfIssue: countryFromList ? countryFromList : 'n/a',
                        expiryDate: dateSelector(),
                        managerApprovedName: props.userName,
                        driver_id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`
                    }).then( response => {
                        putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                            status: null
                        })
                        if (arrayOfImages.length > 0) {
                            let thisArray = [...arrayOfImages]
                            imageArrayPermanent.push(response)
                            thisArray.push(
                                <div key={42} className='imageClassVerification'>
                                    <div className="formNameContainer">
                                        {nameFromList}
                                    </div>
                                    <div>
                                        <img src={outsideImageFile} className='imageOnVerification' alt={nameFromList} onClick={(e, stuff) => handleEditDocuments(e, response)}/>
                                    </div>
                                </div>
                            )
                            setArrayOfImages(thisArray)
                            // handle the images
                            getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                                dispatch(addImages(response.results))
                            })
                            if (nameFromList === 'VAT') {
                                putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                    vat: true
                                })
                            }
                        } else {
                            let thisArray = []
                            let thisLocalArray = []
                            imageArrayPermanent.push(response)
                            thisArray.push(
                                <div key={42} className='imageClassVerification'>
                                <div className="formNameContainer">
                                    {nameFromList}
                                </div>
                                <div>
                                    <img src={outsideImageFile} className='imageOnVerification' alt={nameFromList} onClick={(e, stuff) => handleEditDocuments(e, response)}/>
                                </div>
                            </div>
                            )
                            setArrayOfImages(thisArray)
                            // handle the images
                            getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                                dispatch(addImages(response.results))
                            })
                            if (nameFromList === 'VAT') {
                                putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                    vat: true
                                })
                            }
                        }
                        if (props.handleReload) {
                            props.handleReload()
                        }
                        setSubmitted()
                        setNameFromList('')
                        setCountryFromList('')
                        setCountryFromListArray([])
                        setDisplayCountryArray('names_list_array_container_none')
                    })
                } else {
                    // if (props.station.includes(props.selectedDriver.location) || props.selectedDriver.location === 'DCF1') {
                        // handle not entering date
                        const dateSelector = () => {
                            if (manualDate) {
                                try {
                                    new Date(manualDate)
                                } catch (error) {
                                    console.log(error)
                                }
                                return new Date(manualDate).toDateString()
                            }
                            else if (dateOption) {
                                return dateSelected.toDateString()
                            } 
                            else {
                                return 'Thu Jan 3 2030'
                            }
                        }
                        async function postData(url = '', data = {}) {
                            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                            let originalText = bytes.toString(CryptoJS.enc.Utf8);
                            const response = await fetch(url, {
                                method: 'POST', 
                                mode: 'cors',
                                cache: 'no-cache',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Token ${originalText}`
                                },
                                body: JSON.stringify(data)
                                });
                
                            return response ? response.json() : console.log('no reponse')
                        };
                        postData(`https://backendpajamas.herokuapp.com/images/`, {
                            imagesLink: outsideImageFile,
                            name: nameFromList,
                            countryOfIssue: countryFromList ? countryFromList : 'n/a',
                            expiryDate: dateSelector(),
                            driver_id: `https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`
                        }).then( response => {
                            putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                status: null
                            })
                            if (arrayOfImages.length > 0) {
                                let thisArray = [...arrayOfImages]
                                imageArrayPermanent.push(response)
                                thisArray.push(
                                    <div key={42} className='imageClassVerification'>
                                        <div className="formNameContainer">
                                            {nameFromList}
                                        </div>
                                        <div>
                                            <img src={outsideImageFile} className='imageOnVerification' alt={nameFromList} onClick={(e, stuff) => handleEditDocuments(e, response)}/>
                                        </div>
                                    </div>
                                )
                                setArrayOfImages(thisArray)
                                // handle the images
                                getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                                    dispatch(addImages(response.results))
                                })
                                if (nameFromList === 'VAT') { 
                                    putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                        vat: true
                                    })
                                }
                            } else {
                                let thisArray = []
                                let thisLocalArray = []
                                imageArrayPermanent.push(response)
                                thisArray.push(
                                    <div key={42} className='imageClassVerification'>
                                    <div className="formNameContainer">
                                        {nameFromList}
                                    </div>
                                    <div>
                                        <img src={outsideImageFile} className='imageOnVerification' alt={nameFromList} onClick={(e, stuff) => handleEditDocuments(e, response)}/>
                                    </div>
                                </div>
                                )
                                setArrayOfImages(thisArray)
                                // handle the images
                                getData('https://backendpajamas.herokuapp.com/images/').then( response => {
                                    dispatch(addImages(response.results))
                                })
                                if (nameFromList === 'VAT') {
                                    putData(`https://backendpajamas.herokuapp.com/drivers/${props.selectedDriver.driver_id}/`, {
                                        vat: true
                                    })
                                }
                            }
                            if (props.handleReload) {
                                props.handleReload()
                            }
                            setSubmitted()
                            setNameFromList('')
                            setCountryFromList('')
                            setCountryFromListArray([])
                            setDisplayCountryArray('names_list_array_container_none')
                        })
                    // } else {
                    //     setErrorMessage(
                    //         <div className='errorMessageAllPages'>
                    //             <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                    //             <button className='errorButton' onClick={handleDeleteError}>Return</button>
                    //         </div>
                    //     )
                    // }
                }   
            }
        } else {
            setErrorMessage(
                <div className='errorMessageAllPages'>
                <h3 id='errorMessage'>Please select a document to upload. </h3>
                <button className='errorButton' onClick={handleDeleteError}>Return</button>
            </div>
            )
        }
    }

    const setSubmitted = () => {
        setSubmitPressed('Added')
        setTimeout( () => {
            setSubmitPressed('Submit')
        }, 2000)
    }

    // make react happy
    const handleChangeCalendar = (e) => {
        // setDateSelected(e.target.value)
        // console.log(e.target.key)
    }

    // make array of images
    useEffect( () => {
        let localArray = []
        let localForChangeArray = []
        if (props.superUser || props.email === "compliance@h2ologistics.co.uk" || props.email === "Compliance@h2ologistics.co.uk" || props.email === 'i.stoykov@h2ologistics.co.uk') {
            if (props.selectedDriver) {
                let dvlaBool = false
                props.selectedDriver.imgArray.forEach( (image, imageID) => {
                    if (!image.storageBool) {
                        if (!image.imagesLink.includes('.pdf')) {
                            if (image.name === 'DVLA Check') {
                                if (dvlaBool === false) {
                                    dvlaBool = true
                                    localArray.push(
                                        <div key={imageID} className='imageClassVerification'>
                                            <div className="formNameContainer">
                                                {image.name}
                                            </div>
                                            <div>
                                                <img src={image.imagesLink} className='imageOnVerification' alt={image.name} onClick={(e, stuff) => handleEditDocuments(e, image)}/>
                                            </div>
                                        </div>
                                    )
                                }
                            } else {
                                localArray.push(
                                    <div key={imageID} className='imageClassVerification'>
                                        <div className="formNameContainer">
                                            {image.name}
                                        </div>
                                        <div>
                                            <img src={image.imagesLink} className='imageOnVerification' alt={image.name} onClick={(e, stuff) => handleEditDocuments(e, image)}/>
                                        </div>
                                    </div>
                                )
                            }
                            localForChangeArray.push(image)
                        } else {
                            if (image.name === 'DVLA Check') {
                                if (dvlaBool === false) {
                                    dvlaBool = true
                                    let pageString = 'pg_1/'
                                    let begginingOfUrl = image.imagesLink.slice(0, 53)
                                    let endOfUrlUrl = image.imagesLink.slice(53)
                                    let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                    let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                    localArray.push(
                                        <div key={imageID} className='imageClassVerification'>
                                            <div className="formNameContainer">
                                                {image.name}
                                            </div>
                                            <div>
                                                <img src={pngUrlPdf} className='imageOnVerification' alt={image.name} onClick={(e, stuff) => handleEditDocuments(e, image)}/>
                                            </div>
                                        </div>
                                    )
                                }
                            } else {
                                let pageString = 'pg_1/'
                                let begginingOfUrl = image.imagesLink.slice(0, 53)
                                let endOfUrlUrl = image.imagesLink.slice(53)
                                let endUrlString = begginingOfUrl.concat(pageString).concat(endOfUrlUrl)
                                let pngUrlPdf = endUrlString.replace(/.pdf/, '.png')
                                localArray.push(
                                    <div key={imageID} className='imageClassVerification'>
                                        <div className="formNameContainer">
                                            {image.name}
                                        </div>
                                        <div>
                                            <img src={pngUrlPdf} className='imageOnVerification' alt={image.name} onClick={(e, stuff) => handleEditDocuments(e, image)}/>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    }
                })
                imageArrayPermanent = localForChangeArray
            }
        } else {
            if (props.selectedDriver) {
                props.selectedDriver.imgArray.forEach( (image, imageID) => {
                    if (!image.storageBool) {
                        localArray.push(
                            <div key={imageID} className='imageClassVerificationTwo'>
                                <div className="formNameContainer">
                                    {image.name}
                                </div>
                            </div>
                        )
                    }
                })
            }
        }
        setArrayOfImages(localArray)
    }, [props.selectedDriver])

    // calendar selectiopn function
    const returnDateFunction = (selectedDate) => {
        setDateSelected(selectedDate)
        setCalendarGate(false)
    }

    // calendar function
    const handleMakingCalendar = () => {
        setCalendarGate(true)
    }

    useEffect( () => {
        if (calendarGate) {
            setTheCalendar(
                <div>
                    <Calendar 
                        startingDay='Sun'
                        returnDate={returnDateFunction}
                    />
                </div>
            )
        } else {
            setTheCalendar(null)
        }
    }, [calendarGate])

    // handle country selection
    let countryList = 
        [
        'Afghanistan',
        'Albania',
        'Algeria',
        'Aland Islands',
        'American Samoa',
        'Anguilla',
        'Andorra',
        'Angola',
        'Antilles - Netherlands',
        'Antigua and Barbuda',
        'Antarctica',
        'Argentina',
        'Armenia',
        'Australia',
        'Austria',
        'Aruba',
        'Azerbaijan',
        'Bosnia and Herzegovina',
        'Barbados',
        'Bangladesh',
        'Belgium',
        'Burkina Faso',
        'Bulgaria',
        'Bahrain',
        'Burundi',
        'Benin',
        'Bermuda',
        'Brunei Darussalam',
        'Bolivia',
        'Brazil',
        'Bahamas',
        'Bhutan',
        'Bouvet Island',
        'Botswana',
        'Belarus',
        'Belize',
        'Cambodia',
        'Cameroon',
        'Canada',
        'Cape Verde',
        'Central African Republic',
        'Chad',
        'Chile',
        'China',
        'Christmas Island',
        'Cocos (Keeling) Islands',
        'Colombia',
        'Congo',
        "Cote D'Ivoire (Ivory Coast)",
        'Cook Islands',
        'Costa Rica',
        'Croatia (Hrvatska)',
        'Cuba',
        'Cyprus',
        'Czech Republic',
        'Democratic Republic of the Congo',
        'Djibouti',
        'Denmark',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'East Timor',
        'Estonia',
        'Equatorial Guinea',
        'Eritrea',
        'Ethiopia',
        'Finland',
        'Fiji',
        'Falkland Islands (Malvinas)',
        'Federated States of Micronesia',
        'Faroe Islands',
        'France',
        'France, Metropolitan',
        'French Guiana',
        'French Polynesia',
        'Gabon',
        'Gambia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Great Britain (UK)',
        'Grenada',
        'Georgia',
        'Greece',
        'Greenland',
        'Guinea',
        'Guadeloupe',
        'S. Georgia and S. Sandwich Islands',
        'Guatemala',
        'Guam',
        'Guinea-Bissau',
        'Guyana',
        'Hong Kong',
        'Heard Island and McDonald Islands',
        'Honduras',
        'Haiti',
        'Hungary',
        'Indonesia',
        'Ireland',
        'Israel',
        'India',
        'British Indian Ocean Territory',
        'Iraq',
        'Iran',
        'Italy',
        'Jamaica',
        'Jordan',
        'Japan',
        'Kenya',
        'Kyrgyzstan',
        'Kiribati',
        'Comoros',
        'Saint Kitts and Nevis',
        'Korea (North)',
        'Korea (South)',
        'Kuwait',
        'Cayman Islands',
        'Kazakhstan',
        'Laos',
        'Lebanon',
        'Saint Lucia',
        'Liechtenstein',
        'Sri Lanka',
        'Liberia',
        'Lesotho',
        'Lithuania',
        'Luxembourg',
        'Latvia',
        'Libya',
        'Macedonia',
        'Macao',
        'Madagascar',
        'Malaysia',
        'Mali',
        'Malawi',
        'Mauritania',
        'Marshall Islands',
        'Martinique',
        'Mauritius',
        'Mayotte',
        'Malta',
        'Mexico',
        'Morocco',
        'Monaco',
        'Moldova',
        'Mongolia',
        'Myanmar',
        'Northern Mariana Islands',
        'Montserrat',
        'Maldives',
        'Mozambique',
        'Namibia',
        'New Caledonia',
        'Niger',
        'Norfolk Island',
        'Nigeria',
        'Nicaragua',
        'Netherlands',
        'Norway',
        'Nepal',
        'Nauru',
        'Niue',
        'New Zealand (Aotearoa)',
        'Oman',
        'Panama',
        'Peru',
        'Papua New Guinea',
        'Philippines',
        'Pakistan',
        'Poland',
        'Saint Pierre and Miquelon',
        'Serbia and Montenegro',
        'Pitcairn',
        'Puerto Rico',
        'Palestinian Territory',
        'Portugal',
        'Palau',
        'Paraguay',
        'Qatar',
        'Reunion',
        'Romania',
        'Russian Federation',
        'Rwanda',
        'Saudi Arabia',
        'Samoa',
        'Saint Helena',
        'Saint Vincent and the Grenadines',
        'San Marino',
        'Sao Tome and Principe',
        'Senegal',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'Solomon Islands',
        'Somalia',
        'South Africa',
        'Spain',
        'Sudan',
        'Suriname',
        'Svalbard and Jan Mayen',
        'Sweden',
        'Switzerland',
        'Syria',
        'USSR (former)',
        'Swaziland',
        'Taiwan',
        'Tanzania',
        'Tajikistan',
        'Thailand',
        'Timor-Leste',
        'Togo',
        'Tokelau',
        'Tonga',
        'Trinidad and Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks and Caicos Islands',
        'Tuvalu',
        'Ukraine',
        'Uganda',
        'United Arab Emirates',
        'United Kingdom',
        'United States',
        'United States Minor Outlying Islands',
        'Uruguay',
        'Uzbekistan',
        'Vanuatu',
        'Vatican City State',
        'Venezuela',
        'Virgin Islands (British)',
        'Virgin Islands (U.S.)',
        'Viet Nam',
        'Wallis and Futuna',
        'Western Sahara',
        'Yemen',
        'Yugoslavia (former)',
        'Zambia',
        'Zaire (former)',
        'Zimbabwe']

    // handle selecting a country
    const handleCountryClick = (e, country) => {
        setCountryFromList(country)
        setCountryFromListArray([])
        setDisplayCountryArray('names_list_array_container_none')
    }   

    // handle selecting name of document
    const handleNameClick = (e, targetName) => {
        setNameFromList(targetName)
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // function for making drop down for names list
    const mouseEnterName = () => {
        let localArray = []
        namesListArray.forEach( (ele, id) => {
            localArray.push(
                <div key={id} className='names_in_names_list_array_forms_two' onClick={(e, targetName) => handleNameClick(e, ele)}>
                    <p>{ele}</p>
                </div>    
            )
        })
        setNameFromListArray(localArray)
        setDisplayNameArray('names_list_array_container')
    }

    // function for mouse leaving names list
    const mouseLeaveName = () => {
        setNameFromListArray([])
        setDisplayNameArray('names_list_array_container_none')
    }

    // list of names for documents
    let namesListArray = [
        'Application Package',
        'Bank Details',
        'BGC',
        'Birth Certificate',
        'D&A test',
        'Driving licence Front',
        'Driving licence Back',
        'DVLA Check',
        'G.I.T. Insurance',
        'ID',
        'ID Back',
        'Motor Insurance',
        'MOT',
        'NIN',
        'Passport',
        'Photo',
        'P.L. Insurance',
        'POA',
        'Rental',
        'Return',
        'TAX',
        'UTR',
        'V5',
        'VAT',
        'Visa',
        'Other',
    ]

    // dealing with country selection
    const handleChange = (e) => {
        let localArray = []
        if (e.target.value) {
            countryList.forEach( (ele, id) => {
                if (ele.toLowerCase().includes(e.target.value.toLowerCase())) {
                    localArray.push(
                        <div key={id} className='names_in_names_list_array_forms_edit' onClick={(e, targetName) => handleCountryClick(e, ele)}>
                            <p>{ele}</p>
                        </div> 
                    )
                }
            })
        }
        setCountryFromListArray(localArray)
        setDisplayCountryArray('names_list_array_container')
    }

    // handle click turn things blank
    const handleClick = () => {
        setCountryFromList(null)
        setCountryFromListArray([])
        setDisplayCountryArray('names_list_array_container_none')
    }

    // return to the verification screen
    const returnToVerification = () => {
        props.returnMe(imageArrayPermanent)
    }

    // return to non documents page
    var returnButton
    if (props.fromDocument) {
        returnButton = (
            <div >
                <button className='compliance_add_driver_button_submit' onClick={returnToVerification}>
                    <span className='span_in_complaince_button'>Return</span> 
                </button>
            </div>
        )
    }

    // enter manual date
    const handleChangeManualDate = (e) => {
        setManualDate(e.target.value)
    }

    // switch between date and no date
    const handleKeyPress = (e) => {
        setManualGate(true)
        setCalendarGate(false)
        setManualDate('')
    }

    // handle changing the text in the expiry date
    useEffect( () => {
        if (nameFromList === 'D&A test') {
            setDateText('Date Passed:')
        } else {
            setDateText('Expiry Date:')
        }
    }, [nameFromList])

    useEffect( () => {
        if (manualDate || manualGate) {
            setManualDateDiv(
                <>
                    <h3 className='documents_h3'>{dateText}</h3>
                    <input 
                        type='text' 
                        value={manualDate} 
                        onChange={handleChangeManualDate}
                        className='document_input_forms'
                    />
                </>
            )
        } else {
            setManualDateDiv(
                <>
                    <h3 className='documents_h3'>{dateText}</h3>
                    <input 
                        type="text" 
                        name="expiryDate"  
                        className='document_input_forms' 
                        value={dateSelected instanceof Date ? dateSelected.toLocaleDateString('en-GB') : dateSelected} 
                        onKeyPress={handleKeyPress}
                        onChange={handleChangeCalendar} 
                        autoComplete='off' 
                        onClick={handleMakingCalendar}
                    />
                    {theCalendar}
                </>
            )
        }
    }, [manualDate, manualGate, dateText, theCalendar])

    // function for submitting files
    useEffect( () => {
        if (props.selectedDriver && dateOption && countryOption) {
            setSubmitFilesDiv(
                <div className='submit_files_two_freedom'>
                    {optionsSelections}
                    <form onSubmit={handleSubmit} className='form_on_document_page'>
                        <div className='enter_information_documents'>
                            {sizeError}
                            <h3 className='documents_h3'>Upload Image for {props.selectedDriver.name}</h3>
                                <div className='input_information_documents_tab'>
                                <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                <img src={outsideImageFile ? outsideImageFile : ''} alt="" className='uploaded_image'/>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Name of Document:</h3>
                                            <input type="text" 
                                            name="theName"  
                                            value={nameFromList} 
                                            autoComplete='off' 
                                            className='document_input_forms' 
                                            onClick={mouseEnterName}
                                            />
                                            <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                                {nameFromListArray}
                                            </div>
                                    </div>
                                    <div className='inner_input_information_documents_tab'>
                                        {manualDateDiv}
                                    </div>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Country of Issue:</h3>
                                            <input type="text" name="country" value={countryFromList} className='document_input_forms' autoComplete='off' onChange={handleChange} onClick={handleClick}/>
                                            <div className={displayCountryArray} >
                                                {countryFromListArray}
                                            </div>
                                    </div>
                                </div>
                                <br />
                            <div className='overallImageArrayVerification'>
                                {arrayOfImages}
                            </div>
                            <div className="formsButtonContainer">
                                <div className="button-container-2" >
                                    <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                                </div> 
                                {returnButton}
                            </div>
                        </div>
                    </form>
                </div>
            )
        } else if (props.selectedDriver && countryOption && !dateOption) {
            setSubmitFilesDiv(
                <div className='submit_files_two_freedom'>
                    {optionsSelections}
                    <form onSubmit={handleSubmit} className='form_on_document_page'>
                        <div className='enter_information_documents'>
                            {sizeError}
                            <h3 className='documents_h3'>Upload Image for {props.selectedDriver.name}</h3>
                                <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                <img src={outsideImageFile ? outsideImageFile : ''} alt="" className='uploaded_image'/>
                                <div className='input_information_documents_tab'>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Name of Document:</h3>
                                            <input type="text" 
                                            name="theName"  
                                            value={nameFromList} 
                                            autoComplete='off' 
                                            className='document_input_forms' 
                                            onMouseEnter={mouseEnterName}
                                            />
                                            <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                                {nameFromListArray}
                                            </div>
                                    </div>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Country of Issue:</h3>
                                            <input type="text" name="country" value={countryFromList} className='document_input_forms' autoComplete='off' onChange={handleChange} onClick={handleClick}/>
                                            <div className={displayCountryArray} >
                                                {countryFromListArray}
                                            </div>
                                    </div>
                                </div>
                                <br />
                            <div className="button-container-2" id="formsButtonSubmit">
                                <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                            </div> 
                            <div className='overallImageArrayVerification'>
                                {arrayOfImages}
                            </div>
                            {returnButton}
                        </div>
                    </form>
                </div>
            )
        } else if (props.selectedDriver && dateOption && !countryOption) {
            setSubmitFilesDiv(
                <div className='submit_files_two_freedom'>
                    {optionsSelections}
                    <form onSubmit={handleSubmit} className='form_on_document_page'>
                        <div className='enter_information_documents'>
                            {sizeError}
                            <h3 className='documents_h3'>Upload Image for {props.selectedDriver.name}</h3>
                                <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                <img src={outsideImageFile ? outsideImageFile : ''} alt="" className='uploaded_image'/>
                                <div className='input_information_documents_tab'>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Name of Document:</h3>
                                            <input type="text" 
                                            name="theName"  
                                            value={nameFromList} 
                                            autoComplete='off' 
                                            className='document_input_forms' 
                                            onMouseEnter={mouseEnterName}
                                            />
                                            <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                                {nameFromListArray}
                                            </div>
                                    </div>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Expiry Date:</h3>
                                            <input type="text" name="expiryDate"  className='document_input_forms' value={dateSelected.toLocaleDateString('en-GB')}  onChange={handleChangeCalendar} autoComplete='off' onClick={handleMakingCalendar}/>
                                            {theCalendar}
                                    </div>
                                </div>
                                <br />
                            <div className="button-container-2" id="formsButtonSubmit">
                                <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                            </div> 
                            <div className='overallImageArrayVerification'>
                                {arrayOfImages}
                            </div>
                            {returnButton}
                        </div>
                    </form>
                </div>
            )
        } else if (props.selectedDriver && !countryOption && !dateOption) {
            setSubmitFilesDiv(
                <div className='submit_files_two_freedom'>
                    {optionsSelections}
                    <form onSubmit={handleSubmit} className='form_on_document_page'>
                        <div className='enter_information_documents'>
                            {sizeError}
                            <h3 className='documents_h3'>Upload Image for {props.selectedDriver.name}</h3>
                                <input type="file" name="file" placeholder="Upload an image" onChange={uploadImage} className='document_input_forms_top'/>
                                <img src={outsideImageFile ? outsideImageFile : ''} alt="" className='uploaded_image'/>
                                <div className='input_information_documents_tab'>
                                    <div className='inner_input_information_documents_tab'>
                                        <h3 className='documents_h3'>Name of Document:</h3>
                                            <input type="text" 
                                            name="theName"  
                                            value={nameFromList} 
                                            autoComplete='off' 
                                            className='document_input_forms' 
                                            onMouseEnter={mouseEnterName}
                                            />
                                            <div className={displayNameArray} onMouseLeave={mouseLeaveName}>
                                                {nameFromListArray}
                                            </div>
                                    </div>
                                </div>
                                <br />
                            <div className="button-container-2" id="formsButtonSubmit">
                                <input type="submit" value={submitPressed} className='compliance_add_driver_button_submit' />
                            </div> 
                            <div className='overallImageArrayVerification'>
                                {arrayOfImages}
                            </div>
                            {returnButton}
                        </div>
                    </form>
                </div>
            )
        }
    }, [props.selectedDriver, dateOption, nameFromList, outsideImageFile, displayNameArray, nameFromListArray, sizeError, optionsSelections, manualDateDiv, arrayOfImages, countryFromListArray, displayCountryArray])

    return (
        <>
        {editPage}
        {errorMessage}
        {submitFilesDiv}
        </>
    )
}

export default FormsDocuments